import { useHprSettings } from "../data/hprSettings/useHprSettings";
import { ECertStatus } from "../models/ICert";
import { IPerson } from "../models/IPerson";
import { getCertStatus } from "../utils/cert.helper";


export type TCertValidationFn = (personCerts: IPerson["certs"]) => ECertStatus | undefined;

export type IUsePersonCertValidatorHook = (requiredCerts: Array<string>) => {
    validatePersonCerts: TCertValidationFn;
};

export const usePersonCertValidator: IUsePersonCertValidatorHook = (requiredCerts) => {

    const { data } = useHprSettings()
    const certs = data?.certs;

    const validatePersonCerts = (personCerts: IPerson["certs"]) => {
        if (!certs || !personCerts || requiredCerts.length < 1) return;
        return getCertStatus(personCerts, certs, requiredCerts)
    }

    return { validatePersonCerts }

};